import { Checkbox } from '@material-ui/core';
import { MUIDataTableMeta } from 'mui-datatables';
import { ISupplierContact } from 'pages/formsCreate/types';
import { useMemo } from 'react';
import React from 'react';

interface IProps {
  suppliersContactList: ISupplierContact[];
  selectedSuppliers: any[];
  metadata: MUIDataTableMeta;
  onChange: (supplierId: string) => void;
}

export const CheckboxTable = ({ onChange, metadata, suppliersContactList, selectedSuppliers }: IProps) => {
  const data = useMemo(() => suppliersContactList[metadata.rowIndex], [suppliersContactList, metadata]);

  const isSelected = useMemo(() => {
    return selectedSuppliers.some((item) => item === Number(data.ID_PESSOA));
  }, [selectedSuppliers, data]);

  return (
    <Checkbox
      edge="start"
      checked={isSelected}
      disableRipple
      style={{ color: '#159B78' }}
      onClick={() => {
        onChange(data.ID_PESSOA);
      }}
    />
  );
};
